export {useOutsideClick} from './useOutsideClick';
export type {UseOutsideClickProps} from './useOutsideClick';
